import { List } from "lodash";
import {MessageMedia, SenderProperty} from './message.model';



export class EmailModel {
    _id?: any;
    uuid: string;
    email_thread_uuid: string;
    sender_property: SenderProperty;
    message_id: string;
    to: List<String>[];
    language_code: string;
    timestamp: Date;
    gateway: string;
    revision: string;
    status: string;
    vrsn: string;
    sender_email: string;
    text?: string;
    cc?: any;
    bcc?: any;
    mime_type?: string;
    subject?: string;
    attachments?: List<MessageMedia>[];
    reply_to_msg?: string;
    references?: string[];
    forwarded_from?: string;
    context_msg_link?: string[];
    is_parent?: Boolean;
    create_date?: Date;
    update_date?: Date;
    created_by?: string;
    updated_by?: string;
    html_body?: string;
    text_body?: string;

}
